import React from 'react'

export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE

export const concourseId = {
  DEV: 189,
  PDN: 191,
}[ENV]

export const idProduct = {
  // DEV: 'NOL_PRODUCTO_107',
  // PDN: 'NOL_PRODUCTO_110',

  DEV: {
    'es-CO': 'NOL_PRODUCTO_107',
    'es-AR': 'NOL_PRODUCTO_008',
    'es-CL': 'NOL_PRODUCTO_009',
    'es-PE': 'NOL_PRODUCTO_110',
    'es-DO': 'NOL_PRODUCTO_111',
    'es-PR': 'NOL_PRODUCTO_112',
    'es-EC': 'NOL_PRODUCTO_113',
    'es-BO': 'NOL_PRODUCTO_114',
    'es-PY': 'NOL_PRODUCTO_115',
  },
  PDN: {
    'es-CO': 'NOL_PRODUCTO_110',
    'es-AR': 'NOL_PRODUCTO_115',
    'es-CL': 'NOL_PRODUCTO_113',
    'es-PE': 'NOL_PRODUCTO_111',
    'es-DO': 'NOL_PRODUCTO_112',
    'es-PR': 'NOL_PRODUCTO_116',
    'es-EC': 'NOL_PRODUCTO_114',
    'es-BO': 'NOL_PRODUCTO_118',
    'es-PY': 'NOL_PRODUCTO_117',
  },
}[ENV][LOCALE]

export const competitionId = {
  DEV: {
    'es-CO': {
      tasks: 414,
    },

    'es-AR': {
      tasks: 415,
    },
    'es-CL': {
      tasks: 416,
    },
    'es-PE': {
      tasks: 417,
    },
    'es-DO': {
      tasks: 418,
    },
    'es-PR': {
      tasks: 419,
    },
    'es-EC': {
      tasks: 420,
    },
    'es-BO': {
      tasks: 421,
    },
    'es-PY': {
      tasks: 422,
    },
  },
  PDN: {
    'es-CO': {
      tasks: 441,
    },
    'es-AR': {
      tasks: 452,
    },
    'es-CL': {
      tasks: 450,
    },
    'es-PE': {
      tasks: 444,
    },
    'es-DO': {
      tasks: 445,
    },
    'es-PR': {
      tasks: 453,
    },
    'es-EC': {
      tasks: 451,
    },
    'es-BO': {
      tasks: 455,
    },
    'es-PY': {
      tasks: 454,
    },
  },
}[ENV][LOCALE]

export const costActivity = 30
export const costHelpActivity = 10
